"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Impact_1 = require("../model/Impact");

var ImpactConverter_1 = require("./ImpactConverter");

var ImpactConverterImpl =
/*#__PURE__*/
function (_ImpactConverter_1$Im) {
  _inherits(ImpactConverterImpl, _ImpactConverter_1$Im);

  function ImpactConverterImpl() {
    _classCallCheck(this, ImpactConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ImpactConverterImpl).apply(this, arguments));
  }

  _createClass(ImpactConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new Impact_1.Impact(conversions.toBigNumber(source.expected), conversions.toBigNumber(source.real), conversions.toBigNumber(source.impact));
    }
  }, {
    key: "documentToObject",
    value: function documentToObject(conversions) {
      var _this = this;

      return function (doc) {
        return _this.toObject(doc, conversions);
      };
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        expected: conversions.fromBigNumber(source.expected),
        real: conversions.fromBigNumber(source.real),
        impact: conversions.fromBigNumber(source.impact)
      });
      return result;
    }
  }]);

  return ImpactConverterImpl;
}(ImpactConverter_1.ImpactConverter);

exports.ImpactConverterImpl = ImpactConverterImpl;